/**
 * auth.js
 * Manages the auth token for the COC Extractor app.
 * Token is stored in sessionStorage.
 */

const TOKEN_KEY = "coc_auth_token";
const USER_KEY = "coc_auth_user";

export function saveToken(token, user) {
  sessionStorage.setItem(TOKEN_KEY, token);

  if (user) {
    sessionStorage.setItem(USER_KEY, JSON.stringify(user));
  }
}

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  try {
    const raw = sessionStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuth() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);

  window.location.replace("/coc_extract/login");
}

export function isLoggedIn() {
  const token = getToken();
  return !!token;
}

export function authHeaders() {
  const token = getToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
}